// extracted by css-extract-rspack-plugin
export default {"logo":"UnBBNF"};